export { AssetId } from '@deltasierra/ids';
import { Brand, createBranded } from '@deltasierra/type-utilities';
import { Client } from '../client/Client';
import { ClientId } from '../client/ClientId';
import { Auditable, HasId, HasTimestamps, ParanoidAuditable } from '../common/model/traits';
import { Location, LocationId } from '../location/Location';
import { LocationCategoryOptionId } from '../location/LocationCategoryOption';

export type CollectionId = Brand<number, 'CollectionId'>;
export const CollectionId = createBranded<CollectionId>();

export type CollectionAccessId = Brand<number, 'CollectionAccessId'>;
export const CollectionAccessId = createBranded<CollectionAccessId>();

export type CollectionLocationCategoryId = Brand<number, 'CollectionLocationCategoryId'>;
export const CollectionLocationCategoryId = createBranded<CollectionLocationCategoryId>();

export const COLLECTION_ACCESS_LEVELS = ['read', 'write'] as const;
export type CollectionAccessLevel = (typeof COLLECTION_ACCESS_LEVELS)[number];

export interface CollectionAccess extends Auditable, HasId<CollectionAccessId>, HasTimestamps, ParanoidAuditable {
    accessLevel: CollectionAccessLevel;
    client?: Client;
    clientId?: ClientId | null;
    collectionId: number;
    expiresAt?: Date | null;

    location?: Location;
    locationId?: LocationId | null;
}

export interface CollectionLocationCategories extends Auditable, HasId<CollectionLocationCategoryId> {
    collectionId: CollectionId;
    locationCategoryOptionId: LocationCategoryOptionId;
}
